import placeholderLocal from '@/assets/sample/placeholder.jpg';

const placeholderRemote = '/-/media/foundation/theming/thumbnails/placeholder.jpg';

/**
 * Generates placeholder image url depending on development/public environment.
 *
 * Args:
 *      localPath (String): Optional local image path.
 *      remotePath (String): Optional remote image path.
 *
 * Returns:
 *      (String): Placeholder image url.
 */
export function generatePlaceholder(localPath, remotePath) {
    // dev environment, use local path
    if (process.env.VUE_APP_ENV === 'development') {
        return localPath;
    }

    // public environment, use relative path
    if (process.env.VUE_APP_ENV === 'public') {
        return remotePath;
    }

    // connected / editor environments, use CM path
    return process.env.VUE_APP_CM_URL + remotePath;
}

export const placeholderImage = generatePlaceholder(placeholderLocal, placeholderRemote);
